var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useMemo, useState } from 'react';
import { AdminLayout } from 'src/Layouts';
import { Container, Title, TableContainer, TopBar } from './styles';
import FilterDropdown from 'src/Components/FilterDropdown';
import dayjs from 'dayjs';
import { useProviderOptions } from 'src/Utils/hooks/useProviderOptions';
import { useBuildingOptions } from 'src/Utils/hooks/useBuildingOptions';
import { useHistory } from 'react-router-dom';
import ServerPaginatedTable from 'src/Components/Common/ServerPaginatedTable';
import { ticketsService } from 'src/Utils/ticketsService';
import AttachmentsModal from './components/AttachmentsModal';
var ProviderArrangements = function () {
    var history = useHistory();
    var _a = useState(null), buildingId = _a[0], setBuildingId = _a[1];
    var _b = useState(null), providerId = _b[0], setProviderId = _b[1];
    var _c = useState('budget_request'), arrangementType = _c[0], setArrangementType = _c[1];
    var _d = useState(null), selectedArrangement = _d[0], setSelectedArrangement = _d[1];
    var columns = useMemo(function () {
        var baseColumns = [
            {
                label: '# Ticket',
                render: function (arrangement) { return arrangement.ticket_number; },
                sortingFieldName: 'ticket_number',
            },
            {
                label: 'Edificio',
                render: function (arrangement) { var _a, _b; return (_b = (_a = arrangement.building) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '-'; },
            },
            {
                label: 'Nombre de proveedor',
                render: function (arrangement) { var _a, _b; return (_b = (_a = arrangement.provider) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '-'; },
            },
            {
                label: 'Servicio del proveedor',
                render: function (arrangement) { var _a, _b; return (_b = (_a = arrangement.provider) === null || _a === void 0 ? void 0 : _a.type_of_service) !== null && _b !== void 0 ? _b : '-'; },
            },
            {
                label: 'Creado por',
                render: function (arrangement) {
                    return arrangement.created_by.first_name + " " + arrangement.created_by.last_name;
                },
            },
        ];
        var authorizedByColumn = {
            label: 'Autorizado por',
            render: function (arrangement) {
                return arrangement.authorized_by
                    ? arrangement.authorized_by.first_name + " " + arrangement.authorized_by.last_name
                    : '-';
            },
        };
        var dateColumn = {
            label: 'Fecha de la gestión',
            render: function (arrangement) {
                return dayjs(arrangement.created_at).format('DD/MM/YY hh:mm a');
            },
        };
        if (arrangementType === 'claim') {
            return __spreadArrays(baseColumns, [dateColumn]);
        }
        return __spreadArrays(baseColumns, [authorizedByColumn, dateColumn]);
    }, [arrangementType]);
    var rowActions = useMemo(function () { return [
        {
            label: 'Ver ticket',
            value: 'view-ticket',
            handler: function (arrangement) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    history.push("/tickets/" + arrangement.ticket_id);
                    return [2 /*return*/];
                });
            }); },
        },
        {
            label: 'Ver documentos adjuntos',
            value: 'view-attached-documents',
            handler: function (arrangement) {
                setSelectedArrangement(arrangement);
            },
            disabled: function (arrangement) { return arrangement.files.length === 0; },
        },
    ]; }, []);
    var providerOptions = useProviderOptions().providerOptions;
    var buildingOptions = useBuildingOptions().buildingOptions;
    var fetchBudgetRequests = function (paginationParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ticketsService.getArrangements(__assign(__assign({}, paginationParams), { type: arrangementType, provider_id: providerId !== null && providerId !== void 0 ? providerId : undefined, building_id: buildingId !== null && buildingId !== void 0 ? buildingId : undefined }))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, {
                            data: response.arrangements,
                            totalPages: response.total_pages,
                        }];
            }
        });
    }); };
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, "Gestiones con proveedores"),
            React.createElement(TableContainer, null,
                React.createElement(TopBar, null,
                    React.createElement(FilterDropdown, { width: 250, label: "Edificio", placeholder: "Seleccione un edificio", value: buildingId, onChange: function (value) {
                            return setBuildingId(value ? Number(value) : null);
                        }, options: buildingOptions, sortOptions: true, clearable: true }),
                    React.createElement(FilterDropdown, { width: 250, label: "Proveedor", placeholder: "Seleccione un proveedor", value: providerId, onChange: function (value) { return setProviderId(value ? Number(value) : null); }, options: providerOptions, sortOptions: true, clearable: true }),
                    React.createElement(FilterDropdown, { width: 250, label: "Tipo de gesti\u00F3n", placeholder: "Seleccione un tipo de gesti\u00F3n", value: arrangementType, onChange: function (value) { return setArrangementType(value); }, options: [
                            {
                                label: 'Solicitudes de presupuesto',
                                value: 'budget_request',
                            },
                            {
                                label: 'Aprobaciones de presupuesto',
                                value: 'payment_authorization',
                            },
                            { label: 'Reclamos', value: 'claim' },
                        ] })),
                React.createElement(ServerPaginatedTable, { fetchData: fetchBudgetRequests, queryKey: [
                        'provider-arrangements',
                        arrangementType,
                        providerId,
                        buildingId,
                    ], columns: columns, getRowKey: function (row) { return row.id; }, rowActions: rowActions }))),
        React.createElement(AttachmentsModal, { open: selectedArrangement !== null, onClose: function () { return setSelectedArrangement(null); }, files: selectedArrangement === null || selectedArrangement === void 0 ? void 0 : selectedArrangement.files })));
};
export default ProviderArrangements;
